'use client'

import { Card } from '@inflow/ui/components/card';
import SectionWrapper from '../Section'

export default function () {
  return (
    <SectionWrapper title=''>
      <Card className='border-0 p-6'>
        <p className="text-center text-2xl">Gerard Minack has been advising the largest, and most sophisticated investors for over 35 years. He has helped them navigate cycles starting with the aftermath of the 1987 crash. He is known for his data-driven analysis of macro trends and how they will impact investor porfolios.</p>

        {/* <div className='w-full text-center'>
          <NavLink href="/about">
            <Button>Learn more</Button>
          </NavLink>
        </div> */}
      </Card>
    </SectionWrapper>
  );
}
